<template>
    <div>
        熊猫已经挂掉啦
    </div>
    <!-- <video width="100%" ref="xm_audio" autoplay muted @click="test">
        <source src="../../assets/mp4/xm.mp4" type="video/mp4">
    </video> -->
</template>

<script>

export default {
    name: 'XiongMaoView',
    data() {
        return {}
    },
    computed: {},
    methods: {
        test() {
            this.$refs.xm_audio.muted = false
        }
    },
    filters: {},
    props: {},
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch:{}
}
</script>

<style>
#xiongmaoDialog>.el-dialog {
    background-color:transparent;
}
</style>